var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 70,
    viewBox: "0 0 48 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Water_Icon",
    "data-name": "Water Icon",
    d: "M6.963,62.2A27.821,27.821,0,0,1,.028,44.8,28.317,28.317,0,0,1,5.313,26.884c1.783-2.438,3.487-4.907,5.064-7.34L22.526.8a1.757,1.757,0,0,1,2.948,0l12.15,18.744c1.574,2.43,3.278,4.9,5.063,7.34A28.327,28.327,0,0,1,47.973,44.8a27.825,27.825,0,0,1-6.936,17.4,22.5,22.5,0,0,1-34.073,0Zm6.359-40.753c-1.618,2.5-3.36,5.021-5.176,7.5a24.818,24.818,0,0,0-4.614,15.7A24.318,24.318,0,0,0,9.576,59.861,19.274,19.274,0,0,0,24,66.5a19.276,19.276,0,0,0,14.423-6.639,24.311,24.311,0,0,0,6.044-15.215,24.81,24.81,0,0,0-4.614-15.7c-1.831-2.5-3.572-5.028-5.175-7.5L24,4.974ZM26,58.275a1.737,1.737,0,0,1,1.75-1.725c4.825,0,8.751-4.407,8.751-9.824a1.75,1.75,0,0,1,3.5,0C40,54.045,34.5,60,27.75,60A1.737,1.737,0,0,1,26,58.275Z",
    transform: "translate(0)",
    fill: "#00afee"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterIcon);
export default __webpack_public_path__ + "static/media/Water Icon.cc6b7150b3e36085d83a88f1827bbef7.svg";
export { ForwardRef as ReactComponent };